<template>
  <div  />
</template>

<script>

/**
 * Vue: Hero banner (finance-hero)
 * -----------------------------------------------------------------------------
 * Large media section that displays image/video.
 * - Limited interactivity section.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
import Splide from '@splidejs/splide'
export default {
  name: 'FinanceHero',
  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        blockLength: 0,
        autoplay: 0,
      }),
    },
  },

  data() {
    return {
       
      }
  },

  mounted() {
    if (this.liquid.blockLength > 1) {
      this.createCarousel()
    }
  },

  methods: {
    createCarousel() {
      const container = document.querySelector(`#vue-element .section-${this.liquid.sectionId}`)
      const carousel = container.querySelector('.splide')
      new Splide(carousel, {
        type: 'loop',
        autoplay: this.liquid.autoplay,
      }).mount()
    },
  },
}
</script>

<style lang="scss">
@import './finance-hero';
@import '@/components/splide';
</style>
